import { render } from "./incrediLink.vue?vue&type=template&id=5bae0298&scoped=true"
import script from "./incrediLink.vue?vue&type=script&lang=js"
export * from "./incrediLink.vue?vue&type=script&lang=js"

import "./incrediLink.vue?vue&type=style&index=0&id=5bae0298&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bae0298"]])

export default __exports__